
import { GridApi } from "grid-experience-client";
import { createCommonConfigurationForApis } from "./CommonHelper";
import { spire360ApiClient } from "./Spire360ApiClient";
import { AxiosInstance } from "axios";

export function createGridApi(): GridApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === 'true';
  if(isGatewayEnabled){
  const basePath = process.env.REACT_APP_GRID_API_URL_GATEWAY;
  const axiosInstance: AxiosInstance = spire360ApiClient;
  return new GridApi(

    undefined,
    basePath,
    axiosInstance

    // "http://localhost:4000"
  );

  }
  else{
  return new GridApi(

    createCommonConfigurationForApis(),
    `${process.env.REACT_APP_GRID_API_URL}`

    // "http://localhost:4000"
  );
  }
  
}
